import { Divider, Skeleton, Button, message, Tooltip, Collapse  } from 'antd';
import { useEffect, useState } from 'react';
import { json, useLocation,useNavigate  } from "react-router-dom";
import callAPI from '../../comps/fetch/main';

import {style2} from '../signup/main.css'
import {style1} from './main.css'
import logo from '../../images/logo.png'

function InstaAccounts() {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState({"data":[]})
    const [messageApi, contextHolder] = message.useMessage();
    const [loadingPut, setLoadingPut] = useState()
    const [dataPUT, setDataPUT] = useState()
    const [dataPUTSuccess, setDataPUTSuccess] = useState({})

    useEffect(() => {
        if(dataPUTSuccess.code == undefined){
            return

        }
        if(dataPUTSuccess.code == 200){
            message.destroy()
            message.success("Account Linked")
            localStorage.setItem("token" , dataPUTSuccess["data"]["token"])
            sessionStorage.clear();
            localStorage.removeItem("refCode")
            localStorage.setItem("ig_id" , dataPUT["connected_instagram_account"]["username"])
            localStorage.removeItem("pages")
            navigate('/')
        }
        else{

            message.destroy()
            message.error(dataPUTSuccess?.message	|| "Error contact support.");
            setDataPUTSuccess({})
            
        }
        
    } , [dataPUTSuccess])

    useEffect(() => {
        if(loading == true){
            return
        }
        let apiURL = `ig-accounts`
        setData(JSON.parse(localStorage.getItem("pages")))
        
    }, [])
        // callAPI({url:apiURL, method: "GET", loadingState:setLoading ,  dataState:setData}  )
        
    useEffect(() => {
        if(loadingPut == undefined || !loadingPut){
            return
        }
        message.loading("Please Wait")
    }, [loadingPut])

    useEffect(() => {
        
        if(dataPUT == undefined){
            return
        }
        
        let apiURL = "fb-page-update"

        callAPI({url:apiURL, method: "PUT", body: dataPUT, loadingState:setLoadingPut ,  dataState:setDataPUTSuccess}  )
    } , [dataPUT])

    return(
        <div className='account-setup ig-list-page'>
       <img src="/logo192.png" alt="Logo" style={{ height: '62px', width: '62px' }} />
       <div className='core-div'>
       <div className='flex-space-between ig-list-header'>
            <div className='header-content'>
                <h1>Choose your IG account</h1>
                <p>Please select your instagram account.</p>
            </div>
            
            <div className='button-left'>
                <a target='_blank' href='https://instagram.com/instant.dm' className='help'>Need Help?</a>
            </div>
        
                
        </div>

        <div className='flex-space-between ig-list-core'>

           

            <div className='account-list'>
                {
                    loading && <div>
                    <Skeleton style={{width:'90%' , margin:'0 auto' , marginBottom:'20px'}} loading={loading} active avatar/>
                    <Skeleton style={{width:'90%' , margin:'0 auto' , marginBottom:'20px'}} className='insta-card' loading={loading} active avatar/>
                    <Skeleton style={{width:'90%' , margin:'0 auto' , marginBottom:'20px'}} className='insta-card' loading={loading} active avatar/>
                    </div>
                }
                
                {
              (data?.data != undefined || data?.data != null ) && data.data.map((page) => {
                   
                   if(page?.connected_instagram_account == undefined){
                    return (<div className='insta-card'>
                    <img src={`${page?.connected_instagram_account?.profile_picture_url}`} />
                    <div className ="name-card">
                    <p className='name'>Instagram Not connected</p>
                    <p className='uname'>#{page.id}</p>
                    </div>
                </div>)
                   }
                   return (<div className='insta-card' onClick={() => setDataPUT({...page, scopes: localStorage.getItem("scopes")}) }>
                        <img src={`${page?.connected_instagram_account?.profile_picture_url}`} />
                        <div className ="name-card">
                        <p className='name'>{page?.connected_instagram_account?.name || page?.connected_instagram_account?.username || 'Instagram Not connected'}</p>
                        <p className='uname'>@{page?.connected_instagram_account?.username ||  `FB-PAGE ${page.id}`}</p>
                        </div>
                    </div>)
                })
            }

            {
                data ?.data == undefined && <p style={{color:"rgba(0,0,0,.5)" , textAlign:'center'}}>No account found!</p>
            }
            
            <Collapse items={[
                {key: '1',
                label: 'Facing error or your account missing?',
                children: <div className='not-listed'>

                        <h4 style={{marginBottom:'20px'}}>Your account not listed?</h4>

                        <h5 style={{marginBottom:'0', marginTop:'0'}}>Reason #1</h5>
                        <p style={{marginBottom:'0'}}>May be your account have connected properly, please re-connect your account.</p>
                        <a href='/ig-connect' className='connect-fb' style={{maxWidth:'200px', marginTop:'20px'}}>Re-connect your account</a>
                        <h5 style={{marginBottom:'0'}}>Reason #2</h5>
                        <p style={{marginBottom:'0'}}>May be your IG account not linked to your FB account and FB Page. Try after connecting your IG account to your FB Page.</p>
                        <a href='https://instagram.com/instant.dm' className='help' style={{maxWidth:'200px', marginTop:'20px', backgroundColor:'black', color:'white', textAlign:'center'}}>Contact us!</a>
                        </div>
                                    
            }]} />

</div>
            

        <div>

        </div>
        </div>


        </div>
              
       
        </div>
    )
}


export default InstaAccounts;






// <div className='insta-account-list'>  
//             <h3>Setup your IG Account</h3>
//             <p className='desc'>One last step! Choose your Instagram account to continue.</p>
//             <Divider/>
//             {
//                 loading  && 
//                 <>
//                 <div>
//                 <Skeleton style={{width:'90%' , margin:'0 auto' , marginBottom:'20px'}} loading={loading} active avatar/>
//                 <Skeleton style={{width:'90%' , margin:'0 auto' , marginBottom:'20px'}} className='insta-card' loading={loading} active avatar/>
//                 <Skeleton style={{width:'90%' , margin:'0 auto' , marginBottom:'20px'}} className='insta-card' loading={loading} active avatar/>
//                 </div>
//                 </>
//             }
//             {
//                 data?.data == undefined && <div>
//                 <Skeleton style={{width:'90%' , margin:'0 auto' , marginBottom:'20px'}} loading={loading} active avatar/>
//                 <Skeleton style={{width:'90%' , margin:'0 auto' , marginBottom:'20px'}} className='insta-card' loading={loading} active avatar/>
//                 <Skeleton style={{width:'90%' , margin:'0 auto' , marginBottom:'20px'}} className='insta-card' loading={loading} active avatar/>
//                 </div>
//             }
//             {
//               (data?.data != undefined || data?.data != null ) && data.data.map((page) => {
                   
//                    if(page?.connected_instagram_account == undefined){
//                     return (<div className='insta-card'>
//                     <img src={`https://imagecorsworkers.sanjayhotaction.workers.dev/${page?.connected_instagram_account?.profile_picture_url}`} />
//                     <div className ="name-card">
//                     <p className='name'>Instagram Not connected</p>
//                     <p className='uname'>#{page.id}</p>
//                     </div>
//                 </div>)
//                    }
//                    return (<div className='insta-card' onClick={() => setDataPUT(page) }>
//                         <img src={`https://imagecorsworkers.sanjayhotaction.workers.dev/${page?.connected_instagram_account?.profile_picture_url}`} />
//                         <div className ="name-card">
//                         <p className='name'>{page?.connected_instagram_account?.name || page?.connected_instagram_account?.username || 'Instagram Not connected'}</p>
//                         <p className='uname'>@{page?.connected_instagram_account?.username ||  `FB-PAGE ${page.id}`}</p>
//                         </div>
//                     </div>)
//                 })
//             } 
//             {
//                 !loading && 
//                 <Tooltip title="Make sure your IG is connected with facebook page.">
//                  <Button className='missing-account' danger>My Account is not listed!</Button>
//                 </Tooltip>
//             }    
//             </div> 